import ModuleLoadingBase from './ModuleLoadingBaseContainer';
import loadingComponent from './HOC/loadingComponent';

export default loadingComponent(ModuleLoadingBase);
